<template>
  <div>
    <div :class="$style.title">
      <h2>Участники</h2>
    </div>
    <ul :class="$style.members">
      <member-card
        v-for="(member, index) in members"
        :key="member.id"
        tag="li"
        :member="member"
        :index="index + 1"
        :is-owner="owner?.id === member.id"
        :light="owner?.id === member.id || index === 0"
        :is-top="index === 0"
        :class="[$style.member, index === 0 && $style.firstMember]"
      />
      <li v-for="index in freeSlots" :key="index" :class="$style.freeSlot">
        <p>Свободный слот</p>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { SquadMember } from '~/services/api/modules/squads/types'
import MemberCard from '~/components/squads/base/MemberCard.vue'

const props = defineProps<{
  members: SquadMember[]
  freeSlots: number
  ownerId: number
}>()

const owner = computed(() =>
  props.members.find(member => member.id === props.ownerId)
)
</script>

<style module lang="scss">
.title {
  margin-bottom: 2.8em;

  h2 {
    @include typo-get(headline-m);
  }
}

.members {
  display: flex;
  flex-wrap: wrap;
  gap: 2em;

  @include down(md) {
    flex-direction: column;
  }
}

.member {
  width: calc(50% - 1em);

  @include down(md) {
    width: 100%;
  }
}

.firstMember {
  width: 100%;
}

.freeSlot {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid color-get(--root-rgb-bg-card);
  border-radius: 1.2em;
  padding: 2em 2.4em;
  width: calc(50% - 1em);

  p {
    @include typo-get(headline-m);
    color: color-get(--root-rgb-text-2);
  }

  @include down(md) {
    width: 100%;
  }
}
</style>
